export type OperationToken = number;

export class OperationController {
  private generation = 0;
  private busyOwner?: OperationToken;

  begin(): OperationToken {
    this.generation += 1;
    return this.generation;
  }

  beginBusy(): OperationToken {
    const token = this.begin();
    this.busyOwner = token;
    return token;
  }

  invalidate() {
    this.generation += 1;
  }

  isCurrent(token: OperationToken) {
    return token === this.generation;
  }

  isBusy() {
    return this.busyOwner !== undefined;
  }

  finishBusy(token: OperationToken) {
    if (this.busyOwner !== token) return false;
    this.busyOwner = undefined;
    return true;
  }
}
